import { PolymerElement, html } from '@polymer/polymer/polymer-element';
import '@polymer/iron-collapse/iron-collapse';
import '../../style-modules/paper-tooltip-style';
import '../../style-modules/paper-table-style';
import '../../paper-table/paper-table';

export class KatapultWidget extends PolymerElement {
  static get template() {
    return html`
      <style include="paper-tooltip-style paper-table-style">
        :host {
          display: block;
          width: 100%;
          /* min-width: 375px;  */
          max-width: 850px;
          justify-content: flex-start;
        }
        :host([edit-mode='true']:not([hide-remove-icon='true'])) .removeIcon {
          border-radius: 999px;
          background-color: rgb(215, 0, 0);
          width: 24px;
          height: 24px;
          z-index: 3;
          display: block;
          position: relative;
          top: 12px;
          left: -8px;
          color: #fff;
          cursor: pointer;
        }
        :host([edit-mode='false']) .removeIcon,
        .removeIcon {
          display: none;
        }
        .collapseIcon {
          color: #424242;
          cursor: pointer;
          user-select: none;
          -webkit-user-select: none; /* Safari */
          align-items: center;
        }
        .widgetWrapper {
          border: 1px solid var(--paper-grey-300);
          border-radius: 16px;
          background-color: #fff;
          overflow: hidden;
        }
        /* since the widget could make use of paper-header-content,
        a style module for the styling of the header could be shared
        by both paper-header-content and KatapultWidget */
        #widgetHeader {
          display: flex;
          justify-content: space-between;
        }
        .headerPiece {
          margin: auto;
          overflow: unset;
          white-space: nowrap;
        }
        .widgetBody {
          justify-content: center;
          padding: 12px;
        }
        #widgetTitle,
        #widgetTitle > *,
        .widgetTitleText {
          justify-content: flex-start;
          font-size: 14pt;
          color: #424242;
          margin: 0px;
          flex-grow: 1;
        }
        #primaryControl {
          justify-content: flex-end;
          flex: 1.5;
        }
        [slot='header'] {
          padding-left: 12px;
          padding-right: 12px;
          text-transform: none;
        }
        :host([edit-mode='true']) [slot='header'] {
          cursor: grab;
        }
        [slot='header-end'] {
          padding-right: 12px;
        }
        [slot='content'] {
          background: var(--paper-grey-50);
          padding: 12px 24px;
        }
        #widgetHeader.false {
          display: none;
        }
        :host([edit-mode='true']) .headerDragHandle {
          display: inline;
          padding-right: 0;
          cursor: grab;
        }
        :host([edit-mode='false']) .headerDragHandle,
        .headerDragHandle {
          display: none;
        }
        .headerDragHandle:active {
          cursor: grabbing;
        }
        .disabledContainer {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1;
        }
      </style>

      <material-icon class="removeIcon" icon="remove" on-click="fireRemoveWidgetEvent"></material-icon>

      <div style="position: relative;">
        <template is="dom-if" if="{{disabledMode}}">
          <div class="disabledContainer">${this.disabledMessageTemplate}</div>
        </template>
        <paper-table class="widgetWrapper">
          ${this.dataBaseTemplate}
          <!-- WIDGET HEADER -->
          <!-- generic header with dividers -->
          <paper-row class$="[[_genericAndDividers()]]" divider id="widgetHeader">
            <paper-cell shrink class="headerDragHandle">
              <material-icon icon="drag_indicator"></material-icon>
            </paper-cell>
            <paper-cell id="widgetTitle" class="headerPiece">${this.widgetTitleTemplate}</paper-cell>
            <!-- ${this.widgetHeaderContent} -->
            <paper-cell style="padding: 0px;" id="primaryControl" class="headerPiece">${this.primaryControlTemplate}</paper-cell>
            <paper-cell shrink>
              <paper-tooltip for="collapseSymbol" position="left">Collapse(-) / Expand(+) Widget</paper-tooltip>
              <material-icon
                class="headerPiece collapseIcon"
                on-click="toggle"
                id="collapseSymbol"
                icon="remove"
                size="small"
              ></material-icon>
            </paper-cell>
          </paper-row>
          <!-- generic header withOUT dividers -->
          <paper-row class$="[[_genericNoDividers()]]" id="widgetHeader">
            <paper-cell shrink class="headerDragHandle">
              <material-icon icon="drag_indicator"></material-icon>
            </paper-cell>
            <paper-cell id="widgetTitle" class="headerPiece">${this.widgetTitleTemplate}</paper-cell>
            <!-- ${this.widgetHeaderContent} -->
            <paper-cell style="padding: 0px;" id="primaryControl" class="headerPiece">${this.primaryControlTemplate}</paper-cell>
            <paper-cell shrink>
              <paper-tooltip for="collapseSymbol" position="left">Collapse(-) / Expand(+) Widget</paper-tooltip>
              <material-icon
                class="headerPiece collapseIcon"
                on-click="toggle"
                id="collapseSymbol"
                icon="remove"
                size="small"
              ></material-icon>
            </paper-cell>
          </paper-row>
          <!-- paper header content -->
          <template is="dom-if" if="{{paperHeader}}">
            <paper-header-content white no-click-row icon="[[icon]]">
              <div slot="header" class="widgetTitleText">${this.headerTemplate}</div>
              <div slot="header-end">
                ${this.headerEndTemplate}
                <paper-tooltip for="collapseSymbol" position="left">Collapse(-) / Expand(+) Widget</paper-tooltip>
                <material-icon class="collapseIcon" on-click="toggle" id="collapseSymbol" icon="remove" size="small"></material-icon>
              </div>
              <div slot="content">${this.contentTemplate}</div>
            </paper-header-content>
          </template>
          <!-- WIDGET CONTENT -->
          <iron-collapse id="collapse" opened>
            <template is="dom-if" if="{{!paperTableBody}}">
              <div class="widgetBody collapse-content">${this.bodyTemplate}</div>
            </template>
            <template is="dom-if" if="{{paperTableBody}}"> ${this.bodyTemplate} </template>
          </iron-collapse>
        </paper-table>
        ${this.footNote}
      </div>
    `;
  }

  // all the pieces with default values (to be overriden by specific widget)
  static get dataBaseTemplate() {
    return html``;
  }
  static get widgetTitleTemplate() {
    return html`<span>*Needs Title*</span>`;
  }
  static get widgetHeaderContent() {
    return html` <style>
        span {
          flex-grow: 3;
        }
      </style>
      <span class="headerPiece">Middle Span</span>`;
  }
  static get disabledMessageTemplate() {
    return html``;
  }
  static get primaryControlTemplate() {
    return html``;
  }
  static get headerTemplate() {
    return html`<span>*Needs Header*</span>`;
  }
  static get headerEndTemplate() {
    return html``;
  }
  static get contentTemplate() {
    return html`<p>*Missing Content*</p>`;
  }
  static get bodyTemplate() {
    return html`<p style="text-align: center">*No body. So this is what you get.*</p>`;
  }
  static get footNote() {
    return html``;
  }

  static get properties() {
    return {
      // default is generic header with dividers and div body
      paperHeader: {
        type: Boolean,
        value: false
      },
      dividers: {
        type: Boolean,
        value: true
      },
      paperTableBody: {
        type: Boolean,
        value: false
      },
      icon: {
        type: String,
        value: 'expand_more'
      },
      disabledMode: {
        type: Boolean,
        value: false,
        observer: '_disabledModeChanged'
      }
    };
  }

  static get importMeta() {
    return import.meta;
  }

  constructor() {
    super();
  }

  ready() {
    super.ready();
    // this.dispatchEvent(new CustomEvent('widget-initialized', { detail: { event: 'initialize', widget: super, target: super }, bubbles: true, composed: false }));
    this.dispatchEvent(new CustomEvent('widget-ready', { detail: { widget: this }, bubbles: true, composed: true }));
  }

  _genericAndDividers() {
    return !this.paperHeader && this.dividers ? 'true' : 'false';
  }

  _genericNoDividers() {
    return !this.paperHeader && !this.dividers ? 'true' : 'false';
  }

  _disabledModeChanged() {
    const widgetWrapper = this.shadowRoot.querySelector('.widgetWrapper');
    if (!widgetWrapper) return;
    widgetWrapper.style.pointerEvents = this.disabledMode ? 'none' : 'auto';
    widgetWrapper.style.opacity = this.disabledMode ? 0.4 : 1;
    widgetWrapper.style['user-select'] = this.disabledMode ? 'none' : 'auto';
  }

  fireRemoveWidgetEvent() {
    // give the widget the "remove" ID so that /home knows exactly which one to remove
    this.id = 'remove';
    const removeWidget = new CustomEvent('remove-widget-clicked', {
      detail: {
        widget: this,
        id: this.id, // for widget removal (frontend and backend)
        parentElementId: this.parentElement.id
      }, // for removing the widget from the right case in the backend
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(removeWidget);
  }

  toggle() {
    this.$.collapse.toggle();
    const symbols = this.shadowRoot.querySelectorAll('.collapseIcon');
    if (!this.$.collapse.opened) {
      symbols.forEach((symbol) => {
        symbol.icon = 'add';
      });
    } else {
      symbols.forEach((symbol) => {
        symbol.icon = 'remove';
      });
    }
  }
}
